import Endpoints from 'constants/Endpoints';
import {RestRequestGET, RestRequestPOST} from 'libs/RestRequest';


const changeDates = async (demandId, {roundId, endDate, openOfferDate}) => {
    const data = {
        roundId,
        endDate: endDate.format(),
        openOfferDate: openOfferDate.format()

    }
    return await RestRequestPOST(Endpoints.ADDITIONAL_ROUND_CHANGE_DATES(demandId), data);
};

const getOffersDecryptionStatus = async (roundId) => {
    return await RestRequestGET(Endpoints.RFX_OFFERS_DECRYPTION_STATUS_LIGHT(roundId));
}

const getOffersDecryptionProgress = async (roundId) => {
    return await RestRequestGET(Endpoints.RFX_OFFERS_DECRYPTION_PROGRESS(roundId));
}

const startOffersDecryptionProcess = async (roundId) => {
    return await RestRequestPOST(Endpoints.RFX_OFFERS_DECRYPTION_START(roundId));
}

export default {
    startOffersDecryptionProcess,
    getOffersDecryptionStatus,
    getOffersDecryptionProgress,
    changeDates
}